import { useEffect, useState } from "react";

type ScreenSizeState = {
  width: number | undefined;
  height: number | undefined;
};

export type ScreenSizes = {
  width: number;
  height: number;
  isCalculating: boolean;
};

export const useScreenSizes = (): ScreenSizes => {
  // Keep SSR and first client render identical by starting undefined
  const [sizes, setSizes] = useState<ScreenSizeState | undefined>(undefined);

  useEffect(() => {
    if (globalThis.window === undefined) return;

    const getWidth = () => {
      if (globalThis.window === undefined) {
        return undefined;
      }
      return {
        height: globalThis.window.innerHeight,
        width: globalThis.window.innerWidth,
      };
    };
    const handleResize = () => setSizes(getWidth());
    // Set initial width after mount, then subscribe to changes
    handleResize();
    globalThis.window.addEventListener("resize", handleResize);
    return () => globalThis.window.removeEventListener("resize", handleResize);
  }, []);

  return {
    width: sizes?.width ?? 0,
    height: sizes?.height ?? 0,
    isCalculating: sizes === undefined,
  };
};
